// src/app/redux/actions/campagnesActions.js

// ===== Types =====
export const FETCH_CAMPAGNES_REQUEST = "FETCH_CAMPAGNES_REQUEST";
export const FETCH_CAMPAGNES_SUCCESS = "FETCH_CAMPAGNES_SUCCESS";
export const FETCH_CAMPAGNES_FAIL = "FETCH_CAMPAGNES_FAIL";
export const FETCH_BUDGET_BY_CAMPAGNE_REQUEST = "FETCH_BUDGET_BY_CAMPAGNE_REQUEST";
export const FETCH_BUDGET_BY_CAMPAGNE_SUCCESS = "FETCH_BUDGET_BY_CAMPAGNE_SUCCESS";
export const FETCH_BUDGET_BY_CAMPAGNE_FAIL = "FETCH_BUDGET_BY_CAMPAGNE_FAIL";

export const FETCH_VISIBLE_CAMPAGNES_REQUEST = "FETCH_VISIBLE_CAMPAGNES_REQUEST";
export const FETCH_VISIBLE_CAMPAGNES_SUCCESS = "FETCH_VISIBLE_CAMPAGNES_SUCCESS";
export const FETCH_VISIBLE_CAMPAGNES_FAIL = "FETCH_VISIBLE_CAMPAGNES_FAIL";

export const CREATE_CAMPAGNE_REQUEST = "CREATE_CAMPAGNE_REQUEST";
export const CREATE_CAMPAGNE_SUCCESS = "CREATE_CAMPAGNE_SUCCESS";
export const CREATE_CAMPAGNE_FAIL = "CREATE_CAMPAGNE_FAIL";

export const UPDATE_CAMPAGNE_REQUEST = "UPDATE_CAMPAGNE_REQUEST";
export const UPDATE_CAMPAGNE_SUCCESS = "UPDATE_CAMPAGNE_SUCCESS";
export const UPDATE_CAMPAGNE_FAIL = "UPDATE_CAMPAGNE_FAIL";

export const DELETE_CAMPAGNE_REQUEST = "DELETE_CAMPAGNE_REQUEST";
export const DELETE_CAMPAGNE_SUCCESS = "DELETE_CAMPAGNE_SUCCESS";
export const DELETE_CAMPAGNE_FAIL = "DELETE_CAMPAGNE_FAIL";

export const SET_CAMPAGNES_LOADING = "SET_CAMPAGNES_LOADING";


export const fetchBudgetByCampagneRequest = (campagneId) => ({
    type: FETCH_BUDGET_BY_CAMPAGNE_REQUEST,
    payload: { campagneId }
});
export const fetchBudgetByCampagneSuccess = (payload) => ({ type: FETCH_BUDGET_BY_CAMPAGNE_SUCCESS, payload });
export const fetchBudgetByCampagneFail = (error) => ({ type: FETCH_BUDGET_BY_CAMPAGNE_FAIL, error });

// ===== Actions creators (PLAIN OBJECTS) =====
export const setCampagnesLoading = (payload) => ({
    type: SET_CAMPAGNES_LOADING,
    payload,
});

export const fetchCampagnesRequest = () => ({ type: FETCH_CAMPAGNES_REQUEST });
export const fetchCampagnesSuccess = (payload) => ({ type: FETCH_CAMPAGNES_SUCCESS, payload });
export const fetchCampagnesFail = (error) => ({ type: FETCH_CAMPAGNES_FAIL, error });

export const fetchVisibleCampagnesRequest = () => ({ type: FETCH_VISIBLE_CAMPAGNES_REQUEST });
export const fetchVisibleCampagnesSuccess = (payload) => ({ type: FETCH_VISIBLE_CAMPAGNES_SUCCESS, payload });
export const fetchVisibleCampagnesFail = (error) => ({ type: FETCH_VISIBLE_CAMPAGNES_FAIL, error });

export const createCampagneRequest = (payload) => ({ type: CREATE_CAMPAGNE_REQUEST, payload });
export const createCampagneSuccess = (payload) => ({ type: CREATE_CAMPAGNE_SUCCESS, payload });
export const createCampagneFail = (error) => ({ type: CREATE_CAMPAGNE_FAIL, error });

export const updateCampagneRequest = (id, payload) => ({
    type: UPDATE_CAMPAGNE_REQUEST,
    payload: { id, payload },
});
export const updateCampagneSuccess = (payload) => ({ type: UPDATE_CAMPAGNE_SUCCESS, payload });
export const updateCampagneFail = (error) => ({ type: UPDATE_CAMPAGNE_FAIL, error });

export const deleteCampagneRequest = (id) => ({ type: DELETE_CAMPAGNE_REQUEST, payload: { id } });
export const deleteCampagneSuccess = (id) => ({ type: DELETE_CAMPAGNE_SUCCESS, payload: { id } });
export const deleteCampagneFail = (error) => ({ type: DELETE_CAMPAGNE_FAIL, error });
